import { OperatorVehicleModel } from './operator-vehicle.model';

export enum OperatorVehicleTab {
	Active = 0,
	Inactive = 1
}

export interface OperatorVehiclesListRequest {
	isActive: boolean;
}

export interface OperatorVehiclesListResponse {
	items: OperatorVehicleModel[];
	totalRecords: number;
}

export interface OperatorVehicleRidersQuery {
	vehicleId: number;
	search?: string | null;
	skip: number;
	take: number;
	sortField: string | string[];
	sortOrder: number;
}

export interface PagedListResponse<T> {
	items: T[];
	totalRecords: number;
	success: boolean;
	errorMessage?: string;
}
